import { render, staticRenderFns } from "./AboutOrg.vue?vue&type=template&id=2bd9a770&scoped=true"
import script from "./AboutOrg.vue?vue&type=script&lang=js"
export * from "./AboutOrg.vue?vue&type=script&lang=js"
import style0 from "./AboutOrg.vue?vue&type=style&index=0&id=2bd9a770&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9a770",
  null
  
)

export default component.exports